class Mounting {
    mountingId = 0;// 
    module = {}; //quantity inside here
    quantity = 1;
    structureId = "arnJNWFUOQausNSWrAuA";
    structure = {};
    orientation = "portrait";
    azimuth = 0; //0=north
    tilt = 0; //"degrees 0 = horizontal" , 
    height = 0;//"xx m" , //0 m = mounting height 
    area = 0;//"xx m2",
    minlength = 0;
    length = 0;
    rails = [];
    accessories = [];
    nRails=0;
    quantitySupports = 0;   
    nModules=0;

    supports=[];

    // mountings: [
    //     {
    //       module: { altura: 1960, largura: 990 },
    //       type: "ceramica",
    //       nModules: 10,
    //       quantity: 1,
    //       orientation: "portrait",
    //       materiais: {},
    //       listaMateriais: [],
    //     },
    //   ],

    clone(object){
        // var self = this;
        // self = Object.assign(self , object);
        Object.assign(this, object );
      };
  
    constructor(){

    };
    load(m){
      // m = new Mounting();
        this.mountingId = m.mountingId;// 
        this.module = m.module; //quantity inside here
        this.quantity = m.quantity;
        this.structureId = m.structureId;
        this.structure = m.structure;
        this.orientation = m.orientation;
        this.azimuth = m.azimuth; //0=north
        this.tilt = m.tilt; //"degrees 0 = horizontal" , 
        this.height = m.height;//"xx m" , //0 m = mounting height 
        this.area = m.area;//"xx m2",
        this.minlength = m.minlength;
        this.length = m.length;
        this.rails = m.rails;
        this.accessories = m.accessories;
        this.nRails=m.nRails;
        this.quantitySupports = m.quantitySupports;   
        this.nModules=m.nModules;
    }
    calc() {
        var d = new Date();
        this.mountingId = d.getTime();
        this.module.quantity = this.nModules;
        this.rails = [];
        this.accessories = [];
        this.quantitySupports = 0;  
        this.nRails =0 ;
        // this.orientation = orientation;
        // this.structure = structure;
        // this.module = Object.assign({}, module);
        
        //Calc area
        this.area = Math.round(100* this.module.quantity * (this.module.width/1000) * (this.module.height/1000))/100;

        if(this.orientation =="portrait")
            this.minlength = this.module.quantity * this.module.width + (this.module.quantity - 1) * this.structure.lengthBetweenModules + this.structure.endRailLength;
        else
            this.minlength = this.module.quantity * this.module.height + (this.module.quantity - 1) * this.structure.lengthBetweenModules + this.structure.endRailLength;

        this.structure.rails.sort(function (a, b) {
            return b.device.length - a.device.length;
        });

        console.log(JSON.stringify(this.structure.rails))
        var rails = this.structure.rails;

        var c =  this.minlength;
        
        console.log("will start calc: c:" + c);
        var a = 0;
        for (a = 0; a < rails.length; a++) {
            var quantity = 0;
            console.log("rail" + a + ", length:"+ rails[a].device.length);
            if (c > 0) {
                if (a < rails.length - 1) {
                    quantity = Math.floor(c / rails[a].device.length)
                    //console.log(JSON.stringify({quantity}));
                    c -= rails[a].device.length * quantity;
                    if (c > rails[a + 1].device.length) {
                        quantity++;
                        c -= rails[a].device.length * quantity;
                    }
                } else {
                    if (c > 0){
                        quantity =  Math.ceil(c / rails[a].device.length);
                    }
                        
                }
                var r = Object.assign({}, rails[a].device);
                r.quantity = quantity*2* this.quantity;
                if(quantity>0){
                    console.log("will push rail>"+ JSON.stringify(r));
              
                    this.rails.push(r);
            
                }
            }
        }
        this.length = 0;
        for(var b= 0; b< this.rails.length;b++){
            this.length += this.rails[b].length* this.rails[b].quantity/2;
            //alert(this.length)
            this.nRails += this.rails[b].quantity;
        }       
       // alert("nRails:" + this.nRails)
        var nEmendas = this.nRails/2;

        
        //alert("nEmendas:" + nEmendas)
 
            nEmendas -=1; 
            nEmendas = nEmendas*2;
  

        // if( (nEmendas >0) && (this.structure.railConnector)){
        //     if(this.structure.railConnector.code){
        //         var railConnector = this.structure.railConnector;
        //         railConnector.quantity = nEmendas;
        //         this.accessories.push(railConnector);
        //     }
        // }
        if(this.structure.railConnectors){
            for(a = 0; a< this.structure.railConnectors.length ; a++){
               if( (nEmendas >0)){
                    var railConnector = Object.assign({}, this.structure.railConnectors[a]);
                    railConnector.device.quantity = nEmendas*railConnector.quantity;
                    this.accessories.push(railConnector.device);
               }
            }
        }

        //Adicionar acessórios por fórmula
        //0 - nModules
        //1- number of spaces beetween modules
        //2- ending spaces
        //3-rows    
        for (a = 0; a< this.structure.accessories.length;a++){
            console.log("push accessories:" + a)
            var accessory = Object.assign({}, this.structure.accessories[a]);
            var quantity = 0 ;
            if(accessory.formula == 0)
                quantity =  accessory.quantity * Math.ceil(this.module.quantity/ accessory.parameter) ;
            if(accessory.formula == 1)
                quantity = accessory.quantity * Math.ceil((this.module.quantity-1)/ accessory.parameter);
            if(accessory.formula == 2)
                quantity = accessory.quantity * Math.ceil(2/ accessory.parameter);
            if(accessory.formula == 3)
                quantity = accessory.quantity * Math.ceil(1/ accessory.parameter);

            if(quantity>0){
                accessory.device.quantity = quantity * this.quantity;
                console.log("Push:"+ JSON.stringify(accessory.device));
                this.accessories.push(accessory.device)
            }
        }
        var x = this.length - this.structure.endRailLength*2;
        console.log("...x:" + x);
        console.log("...this.structure.endRailLength:" + this.structure.endRailLength);
        console.log("...this.structure.maxLenghtBetweenSupports:" + this.structure.maxLengthBetweenSupports);

        var quantitySupports = Math.floor(x /this.structure.maxLengthBetweenSupports)  +1;
        this.quantitySupports = quantitySupports;
        for(a = 0; a< this.structure.supports.length ; a++){
            var support = Object.assign({}, this.structure.supports[a]);
            support.device.quantity = 2* quantitySupports*support.quantity;
            this.accessories.push(support.device);
        }
    
 
        

        //Adcionar suportes


    }




}




export default Mounting;
